<div [ngClass]="[
  usarScrollInterno ? 'h-full overflow-y-auto overflow-x-hidden bg-white' : 'overflow-x-hidden bg-white',
  esVistaModal ? 'resumen-modo-modal' : 'resumen-modo-sidebar',
  'resumen-estilo-expediente'
]">
  <div [ngClass]="esVistaModal ? 'resumen-contenido p-5 md:p-6 lg:p-7 space-y-6' : 'p-4 space-y-4'" *ngIf="tieneSecciones; else noData">
    <!-- Header -->
    <div class="resumen-note-header" [ngClass]="esVistaModal ? 'border border-slate-200 rounded-xl bg-gradient-to-r from-slate-50 to-white p-4 md:p-5' : 'border-b border-gray-200 pb-3'">
      <div class="flex items-center gap-2">
        <h2 [ngClass]="esVistaModal ? 'text-4xl font-bold text-gray-900 leading-tight' : 'text-xl font-bold text-gray-900'">{{ tituloNotaHeader }}</h2>
      </div>
      <span *ngIf="nota?.created_at" class="mt-1 block text-xs text-gray-500">{{ nota.created_at | date: 'dd/MM/yy HH:mm' }}</span>
      <div class="mt-2 flex flex-wrap items-center gap-2">
        <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border bg-slate-100 text-slate-700 border-slate-200">
          {{ nombreDoctorHeader }}
        </span>
        <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border" [ngClass]="estadoNotaBadgeClass">
          {{ estadoNotaTexto }}
        </span>
      </div>
      <div *ngIf="mostrarBotonResumenCompleto" class="mt-2">
        <button
          type="button"
          class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-[11px] font-semibold bg-[#AE91E3] text-white hover:bg-[#9b7cd1] transition-colors"
          (click)="solicitarVerResumenCompleto()"
        >
          Ver historial completo
        </button>
      </div>
    </div>

    <!-- Antecedentes -->
    <div *ngIf="tieneAntecedentesConDatos" class="resumen-seccion space-y-4">
      <div class="flex items-center gap-2">
        <svg class="w-4 h-4 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
        </svg>
        <h3 [ngClass]="esVistaModal ? 'text-base font-semibold text-gray-900' : 'text-sm font-semibold text-gray-900'">Antecedentes</h3>
      </div>
      <div class="space-y-3">

      <!-- Heredo-familiares -->
      <div *ngIf="tieneAntecedentesHeredofamiliares" class="bg-purple-50 border border-purple-200 rounded-lg p-3">
        <h4 class="text-sm font-semibold text-purple-800 uppercase mb-2">Heredo-familiares</h4>
        <ng-container *ngIf="tieneDetalleEstructuradoHeredofamiliares; else heredoFallback">
          <div class="space-y-2 text-sm text-gray-700">
          <!-- Línea Paterna -->
          <div *ngIf="antecedentesHeredofamiliares.paternos" class="mb-2">
            <p class="text-xs font-semibold text-purple-600 uppercase mb-1">Línea Paterna</p>
            <div *ngIf="antecedentesHeredofamiliares.paternos?.padre" class="flex gap-2 ml-2">
              <span class="font-medium text-gray-600 min-w-[80px]">Padre:</span>
              <span>{{ antecedentesHeredofamiliares.paternos.padre.estado }}
                <ng-container *ngIf="antecedentesHeredofamiliares.paternos.padre.edad"> ({{ antecedentesHeredofamiliares.paternos.padre.edad }} años)</ng-container>
                <ng-container *ngIf="antecedentesHeredofamiliares.paternos.padre.detalles"> - {{ antecedentesHeredofamiliares.paternos.padre.detalles }}</ng-container>
              </span>
            </div>
            <div *ngIf="antecedentesHeredofamiliares.paternos?.abuelo" class="flex gap-2 ml-2">
              <span class="font-medium text-gray-600 min-w-[80px]">Abuelo:</span>
              <span>{{ antecedentesHeredofamiliares.paternos.abuelo.estado }}
                <ng-container *ngIf="antecedentesHeredofamiliares.paternos.abuelo.edad"> ({{ antecedentesHeredofamiliares.paternos.abuelo.edad }} años)</ng-container>
                <ng-container *ngIf="antecedentesHeredofamiliares.paternos.abuelo.detalles"> - {{ antecedentesHeredofamiliares.paternos.abuelo.detalles }}</ng-container>
              </span>
            </div>
            <div *ngIf="antecedentesHeredofamiliares.paternos?.abuela" class="flex gap-2 ml-2">
              <span class="font-medium text-gray-600 min-w-[80px]">Abuela:</span>
              <span>{{ antecedentesHeredofamiliares.paternos.abuela.estado }}
                <ng-container *ngIf="antecedentesHeredofamiliares.paternos.abuela.edad"> ({{ antecedentesHeredofamiliares.paternos.abuela.edad }} años)</ng-container>
                <ng-container *ngIf="antecedentesHeredofamiliares.paternos.abuela.detalles"> - {{ antecedentesHeredofamiliares.paternos.abuela.detalles }}</ng-container>
              </span>
            </div>
            <div *ngIf="antecedentesHeredofamiliares.paternos?.otros" class="flex gap-2 ml-2 text-gray-500 italic">
              <span class="font-medium min-w-[80px]">Otros:</span>
              <span>{{ antecedentesHeredofamiliares.paternos.otros }}</span>
            </div>
          </div>

          <!-- Línea Materna -->
          <div *ngIf="antecedentesHeredofamiliares.maternos" class="mb-2">
            <p class="text-xs font-semibold text-purple-600 uppercase mb-1">Línea Materna</p>
            <div *ngIf="antecedentesHeredofamiliares.maternos?.madre" class="flex gap-2 ml-2">
              <span class="font-medium text-gray-600 min-w-[80px]">Madre:</span>
              <span>{{ antecedentesHeredofamiliares.maternos.madre.estado }}
                <ng-container *ngIf="antecedentesHeredofamiliares.maternos.madre.edad"> ({{ antecedentesHeredofamiliares.maternos.madre.edad }} años)</ng-container>
                <ng-container *ngIf="antecedentesHeredofamiliares.maternos.madre.detalles"> - {{ antecedentesHeredofamiliares.maternos.madre.detalles }}</ng-container>
              </span>
            </div>
            <div *ngIf="antecedentesHeredofamiliares.maternos?.abuelo" class="flex gap-2 ml-2">
              <span class="font-medium text-gray-600 min-w-[80px]">Abuelo:</span>
              <span>{{ antecedentesHeredofamiliares.maternos.abuelo.estado }}
                <ng-container *ngIf="antecedentesHeredofamiliares.maternos.abuelo.edad"> ({{ antecedentesHeredofamiliares.maternos.abuelo.edad }} años)</ng-container>
                <ng-container *ngIf="antecedentesHeredofamiliares.maternos.abuelo.detalles"> - {{ antecedentesHeredofamiliares.maternos.abuelo.detalles }}</ng-container>
              </span>
            </div>
            <div *ngIf="antecedentesHeredofamiliares.maternos?.abuela" class="flex gap-2 ml-2">
              <span class="font-medium text-gray-600 min-w-[80px]">Abuela:</span>
              <span>{{ antecedentesHeredofamiliares.maternos.abuela.estado }}
                <ng-container *ngIf="antecedentesHeredofamiliares.maternos.abuela.edad"> ({{ antecedentesHeredofamiliares.maternos.abuela.edad }} años)</ng-container>
                <ng-container *ngIf="antecedentesHeredofamiliares.maternos.abuela.detalles"> - {{ antecedentesHeredofamiliares.maternos.abuela.detalles }}</ng-container>
              </span>
            </div>
            <div *ngIf="antecedentesHeredofamiliares.maternos?.otros" class="flex gap-2 ml-2 text-gray-500 italic">
              <span class="font-medium min-w-[80px]">Otros:</span>
              <span>{{ antecedentesHeredofamiliares.maternos.otros }}</span>
            </div>
          </div>

          <!-- Hermanos e Hijos -->
          <div *ngIf="antecedentesHeredofamiliares.hermanos" class="flex gap-2">
            <span class="font-medium text-gray-600 min-w-[80px]">Hermanos:</span>
            <span>{{ antecedentesHeredofamiliares.hermanos.cantidad || 0 }}
              <ng-container *ngIf="antecedentesHeredofamiliares.hermanos.detalles"> - {{ antecedentesHeredofamiliares.hermanos.detalles }}</ng-container>
            </span>
          </div>
          <div *ngIf="antecedentesHeredofamiliares.hijos" class="flex gap-2">
            <span class="font-medium text-gray-600 min-w-[80px]">Hijos:</span>
            <span>{{ antecedentesHeredofamiliares.hijos.cantidad || 0 }}
              <ng-container *ngIf="antecedentesHeredofamiliares.hijos.detalles"> - {{ antecedentesHeredofamiliares.hijos.detalles }}</ng-container>
            </span>
          </div>
          <div *ngIf="antecedentesHeredofamiliares.otros" class="flex gap-2 text-gray-500 italic">
            <span class="font-medium min-w-[80px]">Otros:</span>
            <span>{{ antecedentesHeredofamiliares.otros }}</span>
          </div>
          </div>
        </ng-container>
        <ng-template #heredoFallback>
          <div class="text-sm text-gray-700 whitespace-pre-line break-words">
            {{ formatearAntecedentes(antecedentesHeredofamiliares) }}
          </div>
        </ng-template>
      </div>

      <!-- Patológicos -->
      <div *ngIf="tieneAntecedentesPatologicos" class="bg-red-50 border border-red-200 rounded-lg p-3">
        <h4 class="text-sm font-semibold text-red-800 uppercase mb-2">Patológicos</h4>
        <ng-container *ngIf="tieneDetalleEstructuradoPatologicos; else patologicosFallback">
          <div class="space-y-1 text-sm text-gray-700">
          <div *ngIf="antecedentesPatologicos.cronicos_degenerativos">
            <span class="font-medium text-gray-600">Crónicos:</span> {{ antecedentesPatologicos.cronicos_degenerativos }}
          </div>
          <div *ngIf="antecedentesPatologicos.alergicos">
            <span class="font-medium text-gray-600">Alergias:</span> {{ antecedentesPatologicos.alergicos }}
          </div>
          <div *ngIf="antecedentesPatologicos.quirurgicos">
            <span class="font-medium text-gray-600">Qx:</span> {{ antecedentesPatologicos.quirurgicos }}
          </div>
          <div *ngIf="antecedentesPatologicos.transfusiones_si && antecedentesPatologicos.transfusiones?.length > 0">
            <span class="font-medium text-gray-600">Transfusiones:</span>
            <span *ngFor="let t of antecedentesPatologicos.transfusiones; let i = index">
              {{ t.fecha }} ({{ t.tipo }}){{ i < antecedentesPatologicos.transfusiones.length - 1 ? ', ' : '' }}
            </span>
          </div>
          <div *ngIf="antecedentesPatologicos.tatuajes_si">
            <span class="font-medium text-gray-600">Tatuajes:</span>
            {{ antecedentesPatologicos.tatuajes_cantidad || 1 }}
            <span *ngIf="antecedentesPatologicos.tatuajes_cantidad <= 1 && antecedentesPatologicos.tatuajes_anio">({{ antecedentesPatologicos.tatuajes_anio }})</span>
            <span *ngIf="antecedentesPatologicos.tatuajes_cantidad > 1 && antecedentesPatologicos.tatuajes_anios?.length > 0">
              (<span *ngFor="let tat of antecedentesPatologicos.tatuajes_anios; let i = index">{{ tat.anio }}{{ i < antecedentesPatologicos.tatuajes_anios.length - 1 ? ', ' : '' }}</span>)
            </span>
          </div>
          <div class="flex flex-wrap gap-1.5 mt-2">
            <span *ngIf="antecedentesPatologicos.tabaquismo_si" class="px-2 py-0.5 bg-red-100 text-red-700 rounded text-sm">Tabaco</span>
            <span *ngIf="antecedentesPatologicos.alcoholismo_si" class="px-2 py-0.5 bg-amber-100 text-amber-700 rounded text-sm">Alcohol</span>
            <span *ngIf="antecedentesPatologicos.toxicomanias_si" class="px-2 py-0.5 bg-red-100 text-red-700 rounded text-sm">Drogas</span>
          </div>
          <div *ngIf="antecedentesPatologicos.toxicomanias_si && antecedentesPatologicos.toxicomanias_tipo_droga?.length > 0" class="mt-1 text-xs text-gray-600">
            <div *ngFor="let droga of antecedentesPatologicos.toxicomanias_tipo_droga">
              <span class="font-medium">{{ getNombreDroga(droga) }}:</span>
              <span *ngIf="antecedentesPatologicos.toxicomanias_detalles?.[droga]">
                {{ antecedentesPatologicos.toxicomanias_detalles[droga].inicio ? 'Inicio: ' + antecedentesPatologicos.toxicomanias_detalles[droga].inicio : '' }}
                {{ antecedentesPatologicos.toxicomanias_detalles[droga].finalizo ? '- Fin: ' + antecedentesPatologicos.toxicomanias_detalles[droga].finalizo : '' }}
                {{ antecedentesPatologicos.toxicomanias_detalles[droga].cantidad ? '- ' + antecedentesPatologicos.toxicomanias_detalles[droga].cantidad : '' }}
              </span>
            </div>
          </div>
          </div>
        </ng-container>
        <ng-template #patologicosFallback>
          <div class="text-sm text-gray-700 whitespace-pre-line break-words">
            {{ formatearAntecedentes(antecedentesPatologicos) }}
          </div>
        </ng-template>
      </div>

      <!-- No Patológicos -->
      <div *ngIf="tieneAntecedentesNoPatologicos" class="bg-green-50 border border-green-200 rounded-lg p-3">
        <h4 class="text-sm font-semibold text-green-800 uppercase mb-2">No Patológicos</h4>
        <ng-container *ngIf="tieneDetalleEstructuradoNoPatologicos; else noPatologicosFallback">
          <div class="space-y-1 text-sm text-gray-700">
          <div *ngIf="antecedentesNoPatologicos.hemotipo" class="flex gap-2">
            <span class="font-medium text-gray-600">Tipo Sangre:</span>
            <span class="font-bold text-red-700">{{ antecedentesNoPatologicos.hemotipo }}</span>
          </div>
          <div *ngIf="antecedentesNoPatologicos.actividad_fisica">
            <span class="font-medium text-gray-600">Act. Física:</span> {{ antecedentesNoPatologicos.actividad_fisica }}
          </div>
          <div *ngIf="antecedentesNoPatologicos.vivienda">
            <span class="font-medium text-gray-600">Vivienda:</span> {{ antecedentesNoPatologicos.vivienda }}
          </div>
          </div>
        </ng-container>
        <ng-template #noPatologicosFallback>
          <div class="text-sm text-gray-700 whitespace-pre-line break-words">
            {{ formatearAntecedentes(antecedentesNoPatologicos) }}
          </div>
        </ng-template>
      </div>

      <!-- Gineco-obstétricos -->
      <div *ngIf="tieneAntecedentesGinecoObstetricos" class="bg-pink-50 border border-pink-200 rounded-lg p-3">
        <h4 class="text-sm font-semibold text-pink-800 uppercase mb-2">Gineco-obstétricos</h4>
        <ng-container *ngIf="tieneDetalleEstructuradoGinecoObstetricos; else ginecoFallback">
          <div class="grid grid-cols-4 gap-2 text-sm text-center">
          <div *ngIf="antecedentesGinecoObstetricos.gesta">
            <div class="font-medium text-gray-600">G</div>
            <div class="font-bold text-pink-700 text-sm">{{ antecedentesGinecoObstetricos.gesta }}</div>
          </div>
          <div *ngIf="antecedentesGinecoObstetricos.partos">
            <div class="font-medium text-gray-600">P</div>
            <div class="font-bold text-pink-700 text-sm">{{ antecedentesGinecoObstetricos.partos }}</div>
          </div>
          <div *ngIf="antecedentesGinecoObstetricos.cesareas">
            <div class="font-medium text-gray-600">C</div>
            <div class="font-bold text-pink-700 text-sm">{{ antecedentesGinecoObstetricos.cesareas }}</div>
          </div>
          <div *ngIf="antecedentesGinecoObstetricos.abortos">
            <div class="font-medium text-gray-600">A</div>
            <div class="font-bold text-gray-700 text-sm">{{ antecedentesGinecoObstetricos.abortos }}</div>
          </div>
          </div>
        </ng-container>
        <ng-template #ginecoFallback>
          <div class="text-sm text-gray-700 whitespace-pre-line break-words">
            {{ formatearAntecedentes(antecedentesGinecoObstetricos) }}
          </div>
        </ng-template>
      </div>
      </div>
    </div>

    <!-- Signos Vitales -->
    <div *ngIf="signosVitalesGrid.length > 0" class="resumen-seccion">
      <div class="flex items-center gap-2 mb-3">
        <svg class="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
        <h3 [ngClass]="esVistaModal ? 'text-base font-semibold text-gray-900' : 'text-sm font-semibold text-gray-900'">Signos Vitales</h3>
      </div>
      <div [ngClass]="esVistaModal ? 'grid grid-cols-2 md:grid-cols-4 gap-3' : 'grid grid-cols-2 gap-2'">
        <div *ngFor="let signo of signosVitalesGrid"
             [ngClass]="esVistaModal ? 'bg-gradient-to-br from-gray-50 to-white rounded-xl border border-gray-200 p-3 text-center shadow-sm' : 'bg-gradient-to-br from-gray-50 to-white rounded-lg border border-gray-200 p-2 text-center'">
          <div class="w-6 h-6 mx-auto mb-1 flex items-center justify-center text-[#1F4A77]">
            <svg class="w-5 h-5" fill="none" [attr.viewBox]="signo.viewBox">
              <ng-container *ngIf="isIconArray(signo.icono); else singlePath">
                <path *ngFor="let d of getIconPaths(signo.icono)" [attr.d]="d" fill="#1A3C60" />
              </ng-container>
              <ng-template #singlePath>
                <path [attr.d]="signo.icono" fill="#1A3C60" />
              </ng-template>
            </svg>
          </div>
          <p class="text-sm font-medium text-gray-600 leading-tight">{{ signo.nombre }}</p>
          <p class="text-sm font-bold text-gray-900">
            {{ signo.valor }}
            <span class="text-sm text-gray-500 font-normal">{{ signo.unidad }}</span>
          </p>
        </div>
      </div>
    </div>

    <!-- SOAP (solo consulta) -->
    <div *ngIf="tieneSOAPConDatos" class="resumen-seccion space-y-3">
      <div class="flex items-center gap-2">
        <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
        <h3 [ngClass]="esVistaModal ? 'text-base font-semibold text-gray-900' : 'text-sm font-semibold text-gray-900'">SOAP</h3>
      </div>
      <div class="space-y-3">

      <div *ngIf="tieneTextoConContenido(nota?.motivo_consulta)" class="resumen-card resumen-card--purple resumen-card--motivo-consulta bg-white border border-gray-200 rounded-lg p-3">
        <h4 class="text-sm font-semibold text-gray-700 uppercase mb-1">Motivo</h4>
        <div class="text-sm text-gray-700 rich-content" [innerHTML]="nota.motivo_consulta | safeHtml"></div>
      </div>

      <div *ngIf="tieneTextoConContenido(nota?.soap_subjetivo)" class="resumen-card resumen-card--cyan resumen-card--subjetivo bg-white border border-gray-200 rounded-lg p-3">
        <h4 class="text-sm font-semibold text-gray-700 uppercase mb-1">Principio y evolución del padecimiento (subjetivo)</h4>
        <div class="text-sm text-gray-700 rich-content" [innerHTML]="nota.soap_subjetivo | safeHtml"></div>
      </div>

      <div *ngIf="tieneTextoConContenido(nota?.soap_objetivo)" class="resumen-card resumen-card--emerald resumen-card--objetivo bg-white border border-gray-200 rounded-lg p-3">
        <h4 class="text-sm font-semibold text-gray-700 uppercase mb-1">Objetivo</h4>
        <div class="text-sm text-gray-700 rich-content" [innerHTML]="nota.soap_objetivo | safeHtml"></div>
      </div>

      <div *ngIf="tieneTextoConContenido(nota?.soap_analisis)" class="resumen-card resumen-card--rose resumen-card--analisis bg-white border border-gray-200 rounded-lg p-3">
        <h4 class="text-sm font-semibold text-gray-700 uppercase mb-1">Exploración</h4>
        <div class="text-sm text-gray-700 rich-content" [innerHTML]="nota.soap_analisis | safeHtml"></div>
      </div>

      <div *ngIf="tieneTextoConContenido(nota?.soap_plan)" class="resumen-card resumen-card--violet resumen-card--plan bg-white border border-gray-200 rounded-lg p-3">
        <h4 class="text-sm font-semibold text-gray-700 uppercase mb-1">Plan</h4>
        <div class="text-sm text-gray-700 rich-content" [innerHTML]="nota.soap_plan | safeHtml"></div>
      </div>
      </div>
    </div>

    <div class="resumen-seccion" [ngClass]="esVistaModal ? 'space-y-4' : 'space-y-3'">
    <!-- Motivo de Ingreso (solo ingreso) -->
    <div *ngIf="tipoNota === 'ingreso' && tieneTextoConContenido(nota?.motivo_ingreso)" class="resumen-card resumen-card--indigo resumen-card--motivo-ingreso">
      <h3 class="text-sm font-semibold text-gray-900 mb-2">Motivo de ingreso</h3>
      <div class="bg-white border border-gray-200 rounded-lg p-3">
        <div class="text-sm text-gray-700 rich-content" [innerHTML]="nota.motivo_ingreso | safeHtml"></div>
      </div>
    </div>

    <!-- Motivo de la atención (urgencias) -->
    <div *ngIf="tipoNota === 'urgencias' && tieneTextoConContenido(nota?.motivo_atencion)" class="resumen-card resumen-card--orange resumen-card--motivo-atencion">
      <h3 class="text-sm font-semibold text-gray-900 mb-2">Motivo de la atención</h3>
      <div class="bg-white border border-gray-200 rounded-lg p-3">
        <div class="text-sm text-gray-700 rich-content" [innerHTML]="nota.motivo_atencion | safeHtml"></div>
      </div>
    </div>

    <!-- Padecimiento actual (urgencias) -->
    <div *ngIf="tipoNota === 'urgencias' && tieneTextoConContenido(nota?.padecimiento_actual)" class="resumen-card resumen-card--amber resumen-card--padecimiento-actual">
      <h3 class="text-sm font-semibold text-gray-900 mb-2">Padecimiento actual</h3>
      <div class="bg-white border border-gray-200 rounded-lg p-3">
        <div class="text-sm text-gray-700 rich-content" [innerHTML]="nota.padecimiento_actual | safeHtml"></div>
      </div>
    </div>

    <!-- Diagnósticos de Egreso (solo egreso) -->
    <div *ngIf="tipoNota === 'egreso' && tieneTextoConContenido(nota?.diagnosticos_egreso)" class="resumen-card resumen-card--red">
      <h3 class="text-sm font-semibold text-gray-900 mb-2">Diagnósticos de Egreso</h3>
      <div class="bg-white border border-gray-200 rounded-lg p-3">
        <div class="text-sm text-gray-700 rich-content" [innerHTML]="nota.diagnosticos_egreso | safeHtml"></div>
      </div>
    </div>

    <!-- Evolución del Padecimiento -->
    <div *ngIf="tieneEvolucionPadecimiento && tieneTextoConContenido(nota?.evolucion_padecimiento)" class="resumen-card resumen-card--blue resumen-card--evolucion-padecimiento">
      <h3 class="text-sm font-semibold text-gray-900 mb-2">Evolución de padecimiento actual (subjetivo)</h3>
      <div class="bg-white border border-gray-200 rounded-lg p-3">
        <div class="text-sm text-gray-700 rich-content" [innerHTML]="nota.evolucion_padecimiento | safeHtml"></div>
      </div>
    </div>

    <!-- Aparatos y Sistemas (consulta/ingreso/evolucion/egreso) -->
    <div *ngIf="(tipoNota === 'consulta' || tipoNota === 'ingreso' || tipoNota === 'evolucion' || tipoNota === 'egreso') && tieneTextoConContenido(nota?.aparatos_sistemas)" class="resumen-card resumen-card--teal resumen-card--aparatos-sistemas">
      <h3 class="text-sm font-semibold text-gray-900 mb-2">Aparatos y Sistemas</h3>
      <div class="bg-white border border-gray-200 rounded-lg p-3">
        <div class="text-sm text-gray-700 rich-content" [innerHTML]="nota.aparatos_sistemas | safeHtml"></div>
      </div>
    </div>

    <!-- Medicamentos Actuales (consulta/urgencias) -->
    <div *ngIf="(tipoNota === 'consulta' || tipoNota === 'urgencias') && tieneTextoConContenido(nota?.medicamentos_actuales)" class="resumen-card resumen-card--sky resumen-card--medicamentos-actuales">
      <h3 class="text-sm font-semibold text-gray-900 mb-2">Medicamentos Actuales</h3>
      <div class="bg-white border border-gray-200 rounded-lg p-3">
        <div class="text-sm text-gray-700 rich-content" [innerHTML]="nota.medicamentos_actuales | safeHtml"></div>
      </div>
    </div>

    <!-- Plan de Urgencias -->
    <div *ngIf="tipoNota === 'urgencias' && (planUrgenciasData || tieneTextoConContenido(contenidoPlanProcesado))" class="resumen-card resumen-card--orange resumen-card--plan-urgencias">
      <h3 class="text-sm font-semibold text-gray-900 mb-2">Plan de Urgencias</h3>
      <div class="bg-white border border-gray-200 rounded-lg p-3">
        <ng-container *ngIf="planUrgenciasData as plan; else planUrgenciasFallback">
          <div *ngIf="plan.tipo_urgencia" class="mb-4">
            <span
              class="inline-flex items-center px-4 py-2 rounded-full text-sm font-semibold"
              [ngClass]="{
                'bg-green-100 text-green-700 border-2 border-green-200': plan.tipo_urgencia === 'ambulatoria',
                'bg-red-100 text-red-700 border-2 border-red-200': plan.tipo_urgencia === 'hospitalizacion'
              }">
              <svg *ngIf="plan.tipo_urgencia === 'ambulatoria'" class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
              <svg *ngIf="plan.tipo_urgencia === 'hospitalizacion'" class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
              {{ tipoUrgenciaLabel }}
            </span>
          </div>

          <div *ngIf="plan.cita_agendada" class="p-4 bg-green-50 rounded-lg mb-4 border border-green-200">
            <div class="flex items-center gap-2 mb-2">
              <svg class="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              <span class="text-green-700 font-semibold">Cita Agendada</span>
            </div>
            <p class="text-gray-700">
              <span *ngIf="plan.cita_agendada.fecha">{{ plan.cita_agendada.fecha }}</span>
              <span *ngIf="plan.cita_agendada.hora"> a las {{ plan.cita_agendada.hora }}</span>
            </p>
            <p *ngIf="plan.cita_agendada.medico" class="text-gray-600 text-sm mt-1">
              Con: {{ plan.cita_agendada.medico }}
            </p>
          </div>

          <div *ngIf="plan.censo_agregado" class="p-4 bg-purple-50 rounded-lg mb-4 border border-purple-200">
            <div class="flex items-center gap-2 mb-2">
              <svg class="w-5 h-5 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
              <span class="text-purple-700 font-semibold">Agregado al Censo</span>
            </div>
            <p *ngIf="plan.censo_agregado.hospital" class="text-gray-700">
              Hospital: {{ plan.censo_agregado.hospital }}
            </p>
            <p *ngIf="plan.censo_agregado.cama" class="text-gray-600 text-sm mt-1">
              Cama: {{ plan.censo_agregado.cama }}
            </p>
          </div>

          <div *ngIf="tieneTextoConContenido(plan.contenido)" class="text-sm text-gray-700 rich-content" [innerHTML]="plan.contenido | safeHtml"></div>
        </ng-container>

        <ng-template #planUrgenciasFallback>
          <div class="text-sm text-gray-700 rich-content" [innerHTML]="contenidoPlanProcesado | safeHtml"></div>
        </ng-template>
      </div>
    </div>

    <!-- Plan (ingreso/evolucion/egreso) -->
    <div *ngIf="(tipoNota === 'ingreso' || tipoNota === 'evolucion' || tipoNota === 'egreso') && tieneTextoConContenido(contenidoPlanProcesado)" class="resumen-card resumen-card--violet resumen-card--plan">
      <h3 class="text-sm font-semibold text-gray-900 mb-2">Plan</h3>
      <div class="bg-white border border-gray-200 rounded-lg p-3">
        <div class="text-sm text-gray-700 rich-content" [innerHTML]="contenidoPlanProcesado | safeHtml"></div>
      </div>
    </div>

    <!-- Exploración Física -->
    <div *ngIf="tieneTextoConContenido(nota?.exploracion_fisica)" class="resumen-card resumen-card--yellow resumen-card--exploracion-fisica">
      <h3 class="text-sm font-semibold text-gray-900 mb-2">Exploración Física</h3>
      <div class="bg-white border border-gray-200 rounded-lg p-3">
        <div class="text-sm text-gray-700 rich-content" [innerHTML]="nota.exploracion_fisica | safeHtml"></div>
      </div>
    </div>

    <!-- Análisis -->
    <div *ngIf="tieneTextoConContenido(nota?.analisis)" class="resumen-card resumen-card--rose resumen-card--analisis">
      <h3 class="text-sm font-semibold text-gray-900 mb-2">Análisis</h3>
      <div class="bg-white border border-gray-200 rounded-lg p-3">
        <div class="text-sm text-gray-700 rich-content" [innerHTML]="nota.analisis | safeHtml"></div>
      </div>
    </div>
    </div>

    <!-- Diagnósticos -->
    <div *ngIf="diagnosticos.length > 0" class="resumen-seccion">
      <div class="flex items-center gap-2 mb-3">
        <svg class="w-4 h-4 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
        </svg>
        <h3 [ngClass]="esVistaModal ? 'text-base font-semibold text-gray-900' : 'text-sm font-semibold text-gray-900'">Diagnósticos ({{ diagnosticos.length }})</h3>
      </div>
      <div [ngClass]="esVistaModal ? 'grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3' : 'grid grid-cols-1 lg:grid-cols-2 gap-2'">
        <div *ngFor="let diagnostico of diagnosticos; let i = index"
             class="bg-red-50 border border-red-200 rounded-lg p-3 h-full">
          <div class="flex items-start gap-2">
            <span class="w-6 h-6 bg-red-100 rounded flex items-center justify-center flex-shrink-0 text-xs font-bold text-red-600">{{ i + 1 }}</span>
            <div class="flex-1 min-w-0">
              <p class="text-sm font-semibold text-red-800">{{ diagnostico.cie10 || diagnostico.codigo || diagnostico.code }}</p>
              <p class="text-sm text-gray-700">{{ diagnostico.descripcion || diagnostico.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Escalas Cl�nicas -->
    <div *ngIf="escalasClinicas.length > 0" class="resumen-seccion bg-white rounded-xl border-2 border-blue-200 p-4 md:p-5 shadow-sm">
      <div class="flex items-center gap-3 mb-4 pb-3 border-b-2 border-blue-100">
        <div class="p-2 bg-blue-100 rounded-lg">
          <svg class="w-5 h-5 text-blue-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
        </div>
        <h3 [ngClass]="esVistaModal ? 'text-lg font-bold text-gray-900' : 'text-sm font-semibold text-gray-900'">Escalas Clinicas</h3>
        <span class="ml-auto bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm font-semibold">
          {{ escalasClinicas.length }}
        </span>
      </div>

      <div [ngClass]="esVistaModal ? 'grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4' : 'grid grid-cols-1 gap-2'">
        <div
          *ngFor="let escala of escalasClinicas"
          class="rounded-xl p-3 border-2 transition hover:shadow-md"
          [ngClass]="{
            'bg-green-50 border-green-200': getScaleSeverityColor(escala) === 'green',
            'bg-amber-50 border-amber-200': getScaleSeverityColor(escala) === 'amber',
            'bg-red-50 border-red-200': getScaleSeverityColor(escala) === 'red',
            'bg-blue-50 border-blue-200': getScaleSeverityColor(escala) === 'blue'
          }">
          <div class="flex items-center justify-between mb-2">
            <span class="font-bold text-gray-900 text-sm">{{ formatScaleName(escala.scaleKey || escala.nombre || 'Escala') }}</span>
            <span
              *ngIf="getScaleResultClass(escala)"
              class="text-xs font-semibold px-2 py-1 rounded-full"
              [ngClass]="{
                'bg-green-100 text-green-700': getScaleSeverityColor(escala) === 'green',
                'bg-amber-100 text-amber-700': getScaleSeverityColor(escala) === 'amber',
                'bg-red-100 text-red-700': getScaleSeverityColor(escala) === 'red',
                'bg-blue-100 text-blue-700': getScaleSeverityColor(escala) === 'blue'
              }">
              {{ getScaleResultClass(escala) }}
            </span>
          </div>

          <div class="flex items-end gap-2 mb-1">
            <span
              class="text-2xl font-bold"
              [ngClass]="{
                'text-green-700': getScaleSeverityColor(escala) === 'green',
                'text-amber-700': getScaleSeverityColor(escala) === 'amber',
                'text-red-700': getScaleSeverityColor(escala) === 'red',
                'text-blue-700': getScaleSeverityColor(escala) === 'blue'
              }">
              {{ escala.numericScore ?? escala.resultScore ?? escala.resultado ?? '-' }}
            </span>
            <span class="text-xs text-gray-500 mb-1">puntos</span>
          </div>

          <div *ngIf="escala.createdAt || escala.created_at" class="text-xs text-gray-500 mt-1 flex items-center gap-1">
            <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            {{ (escala.createdAt || escala.created_at) | date: 'dd/MM/yyyy HH:mm' }}
          </div>

          <div *ngIf="escala.notes" class="mt-2 pt-2 border-t border-gray-200">
            <p class="text-xs text-gray-600 italic">{{ escala.notes }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Pron�stico (solo egreso) -->
    <div *ngIf="tipoNota === 'egreso' && tieneTextoConContenido(nota?.pronostico)" class="resumen-seccion resumen-card resumen-card--lime">
      <h3 class="text-sm font-semibold text-gray-900 mb-2">Pronóstico</h3>
      <div class="bg-white border border-gray-200 rounded-lg p-3">
        <div class="text-sm text-gray-700 rich-content" [innerHTML]="nota.pronostico | safeHtml"></div>
      </div>
    </div>

    <!-- Paracl�nicos -->
    <div *ngIf="paraclinicos.length > 0" class="resumen-seccion bg-white rounded-xl border-2 border-teal-200 p-4 md:p-5 shadow-sm">
      <div class="flex items-center gap-3 mb-4 pb-3 border-b-2 border-teal-100">
        <div class="p-2 bg-teal-100 rounded-lg">
          <svg class="w-5 h-5 text-teal-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
          </svg>
        </div>
        <h3 [ngClass]="esVistaModal ? 'text-lg font-bold text-gray-900' : 'text-sm font-semibold text-gray-900'">Paraclinicos</h3>
        <span class="ml-auto bg-teal-100 text-teal-700 px-3 py-1 rounded-full text-sm font-semibold">
          {{ paraclinicos.length }}
        </span>
      </div>

      <div [ngClass]="esVistaModal ? 'grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4' : 'grid grid-cols-1 gap-2'">
        <div
          *ngFor="let para of paraclinicos"
          class="rounded-xl p-3 border-2 transition hover:shadow-md"
          [ngClass]="{
            'bg-blue-50 border-blue-200': getParaclinicoColor(para?.tipo || para?.test_type) === 'blue',
            'bg-purple-50 border-purple-200': getParaclinicoColor(para?.tipo || para?.test_type) === 'purple',
            'bg-teal-50 border-teal-200': getParaclinicoColor(para?.tipo || para?.test_type) === 'teal',
            'bg-gray-50 border-gray-200': getParaclinicoColor(para?.tipo || para?.test_type) === 'gray'
          }">
          <div class="flex items-center justify-between gap-2 mb-2">
            <span
              class="text-xs font-semibold px-2 py-1 rounded-full"
              [ngClass]="{
                'bg-blue-100 text-blue-700': getParaclinicoColor(para?.tipo || para?.test_type) === 'blue',
                'bg-purple-100 text-purple-700': getParaclinicoColor(para?.tipo || para?.test_type) === 'purple',
                'bg-teal-100 text-teal-700': getParaclinicoColor(para?.tipo || para?.test_type) === 'teal',
                'bg-gray-100 text-gray-700': getParaclinicoColor(para?.tipo || para?.test_type) === 'gray'
              }">
              {{ formatTipoParaclinico(para?.tipo || para?.test_type) }}
            </span>

            <a
              *ngIf="para?.pdfUrl || para?.file_url"
              [href]="para?.pdfUrl || para?.file_url"
              target="_blank"
              class="text-xs text-gray-500 hover:text-[#AE91E3] flex items-center gap-1">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
              Ver
            </a>
          </div>

          <h4 class="font-bold text-gray-900 mb-1 break-words">
            {{ para?.nombre || para?.test_name || para?.titulo || 'Estudio' }}
          </h4>

          <div *ngIf="para?.fecha || para?.test_date || para?.created_at" class="text-xs text-gray-500 flex items-center gap-1 mb-2">
            <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            {{ (para?.fecha || para?.test_date || para?.created_at) | date: 'dd/MM/yyyy' }}
          </div>

          <div *ngIf="para?.interpretacion || para?.interpretation || para?.contenido || para?.descripcion" class="mt-2 pt-2 border-t border-gray-200">
            <p class="text-xs text-gray-600 line-clamp-3 rich-content" [innerHTML]="(para?.interpretacion || para?.interpretation || para?.contenido || para?.descripcion) | safeHtml"></p>
          </div>

          <div *ngIf="!(para?.interpretacion || para?.interpretation || para?.contenido || para?.descripcion)" class="mt-2 pt-2 border-t border-gray-200">
            <p class="text-xs text-gray-600 line-clamp-3">{{ formatearItem(para) }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Indicaciones -->
    <div *ngIf="indicaciones.length > 0" class="resumen-seccion resumen-coleccion resumen-coleccion--amber">
      <div class="resumen-coleccion-header">
        <div class="flex items-center gap-2">
          <svg class="w-4 h-4 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
          </svg>
          <h3 [ngClass]="esVistaModal ? 'text-base font-semibold text-gray-900' : 'text-sm font-semibold text-gray-900'">{{ nombreIndicaciones }}</h3>
        </div>
        <span class="resumen-coleccion-count">{{ indicaciones.length }}</span>
      </div>

      <div [ngClass]="esVistaModal ? 'resumen-coleccion-grid grid grid-cols-1 xl:grid-cols-2 gap-3' : 'resumen-coleccion-grid space-y-2'">
        <article *ngFor="let indicacion of indicaciones; let i = index" class="resumen-coleccion-item">
          <div class="resumen-coleccion-item-top">
            <span class="resumen-coleccion-index">{{ i + 1 }}</span>
            <div class="flex-1 min-w-0">
              <div class="flex flex-wrap items-center gap-1.5">
                <h4 class="text-sm font-semibold text-gray-900 leading-tight">
                  {{ indicacion.nombre || (indicacion.tipo === 'receta' ? 'Receta medica' : 'Indicacion medica') }}
                </h4>
                <span *ngIf="indicacion.tipo || indicacion.modo_entrada" class="resumen-coleccion-chip">
                  {{ indicacion.modo_entrada === 'texto' ? 'Texto libre' : (indicacion.tipo || 'Formulario') }}
                </span>
              </div>
              <p *ngIf="indicacion.fecha_solicitud || indicacion.created_at || indicacion.fecha" class="text-xs text-gray-500 mt-1">
                {{ (indicacion.fecha_solicitud || indicacion.created_at || indicacion.fecha) | date: 'dd/MM/yy HH:mm' }}
              </p>
            </div>
          </div>

          <div
            *ngIf="indicacion.modo_entrada === 'texto' && indicacion.contenido_html"
            class="resumen-coleccion-item-content mt-2 prose prose-sm max-w-none rich-content"
            [innerHTML]="indicacion.contenido_html | safeHtml">
          </div>

          <div *ngIf="indicacion.modo_entrada !== 'texto' && indicacion.medicamentos?.length" class="resumen-coleccion-item-content mt-2">
            <div class="space-y-2">
              <div *ngFor="let med of indicacion.medicamentos" class="rounded-lg border border-amber-100 bg-white/90 px-3 py-2">
                <p class="text-sm font-medium text-gray-800">{{ med.nombre || med.medicamento || 'Medicamento' }}</p>
                <p *ngIf="med.dosis || med.via || med.frecuencia || med.duracion" class="text-xs text-gray-600 mt-0.5">
                  {{ med.dosis || '' }}<span *ngIf="med.via"> | Via: {{ med.via }}</span><span *ngIf="med.frecuencia"> | {{ med.frecuencia }}</span><span *ngIf="med.duracion"> | {{ med.duracion }}</span>
                </p>
                <p *ngIf="med.indicaciones" class="text-xs text-gray-500 italic mt-1">{{ med.indicaciones }}</p>
              </div>
            </div>
          </div>

          <div
            *ngIf="(indicacion.modo_entrada !== 'texto' && !indicacion.medicamentos?.length) || (indicacion.modo_entrada === 'texto' && !indicacion.contenido_html)"
            class="resumen-coleccion-item-content mt-2 text-sm text-gray-700">
            {{ formatearItem(indicacion) }}
          </div>
        </article>
      </div>
    </div>

    <!-- Solicitudes -->
    <div *ngIf="solicitudes.length > 0" class="resumen-seccion resumen-coleccion resumen-coleccion--indigo">
      <div class="resumen-coleccion-header">
        <div class="flex items-center gap-2">
          <svg class="w-4 h-4 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          <h3 [ngClass]="esVistaModal ? 'text-base font-semibold text-gray-900' : 'text-sm font-semibold text-gray-900'">Solicitudes de estudios</h3>
        </div>
        <span class="resumen-coleccion-count">{{ solicitudes.length }}</span>
      </div>

      <div [ngClass]="esVistaModal ? 'resumen-coleccion-grid grid grid-cols-1 xl:grid-cols-2 gap-3' : 'resumen-coleccion-grid space-y-2'">
        <article *ngFor="let solicitud of solicitudes; let i = index" class="resumen-coleccion-item">
          <div class="resumen-coleccion-item-top">
            <span class="resumen-coleccion-index">{{ i + 1 }}</span>
            <div class="flex-1 min-w-0">
              <div class="flex flex-wrap items-center gap-1.5">
                <h4 class="text-sm font-semibold text-gray-900 leading-tight">
                  {{ solicitud.nombre || solicitud.titulo || 'Solicitud de estudio' }}
                </h4>
                <span *ngIf="solicitud.tipo_solicitud || solicitud.tipo" class="resumen-coleccion-chip">
                  {{ solicitud.tipo_solicitud || solicitud.tipo }}
                </span>
              </div>
              <p *ngIf="solicitud.fecha_solicitud || solicitud.created_at || solicitud.fecha" class="text-xs text-gray-500 mt-1">
                {{ (solicitud.fecha_solicitud || solicitud.created_at || solicitud.fecha) | date: 'dd/MM/yy HH:mm' }}
              </p>
            </div>
          </div>

          <div
            *ngIf="solicitud.contenido || solicitud.descripcion || solicitud.description"
            class="resumen-coleccion-item-content mt-2 text-sm text-gray-700 rich-content"
            [innerHTML]="(solicitud.contenido || solicitud.descripcion || solicitud.description) | safeHtml">
          </div>
          <div *ngIf="!(solicitud.contenido || solicitud.descripcion || solicitud.description)" class="resumen-coleccion-item-content mt-2 text-sm text-gray-700">
            {{ formatearItem(solicitud) }}
          </div>
        </article>
      </div>
    </div>

    <!-- Interconsultas -->
    <div *ngIf="interconsultas.length > 0" class="resumen-seccion resumen-coleccion resumen-coleccion--purple">
      <div class="resumen-coleccion-header">
        <div class="flex items-center gap-2">
          <svg class="w-4 h-4 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
          <h3 [ngClass]="esVistaModal ? 'text-base font-semibold text-gray-900' : 'text-sm font-semibold text-gray-900'">Interconsultas</h3>
        </div>
        <span class="resumen-coleccion-count">{{ interconsultas.length }}</span>
      </div>

      <div [ngClass]="esVistaModal ? 'resumen-coleccion-grid grid grid-cols-1 xl:grid-cols-2 gap-3' : 'resumen-coleccion-grid space-y-2'">
        <article *ngFor="let interconsulta of interconsultas; let i = index" class="resumen-coleccion-item">
          <div class="resumen-coleccion-item-top">
            <span class="resumen-coleccion-index">{{ i + 1 }}</span>
            <div class="flex-1 min-w-0">
              <div class="flex flex-wrap items-center gap-1.5">
                <h4 class="text-sm font-semibold text-gray-900 leading-tight">
                  {{ interconsulta.titulo || interconsulta.especialidad || 'Interconsulta' }}
                </h4>
                <span *ngIf="interconsulta.categoria || interconsulta.especialidad || interconsulta.specialty" class="resumen-coleccion-chip">
                  {{ interconsulta.categoria || interconsulta.especialidad || interconsulta.specialty }}
                </span>
              </div>
              <p *ngIf="interconsulta.fecha_solicitud || interconsulta.created_at || interconsulta.fecha" class="text-xs text-gray-500 mt-1">
                {{ (interconsulta.fecha_solicitud || interconsulta.created_at || interconsulta.fecha) | date: 'dd/MM/yy HH:mm' }}
              </p>
            </div>
          </div>

          <div
            *ngIf="interconsulta.contenido || interconsulta.descripcion || interconsulta.description || interconsulta.motivo || interconsulta.reason"
            class="resumen-coleccion-item-content mt-2 text-sm text-gray-700 rich-content"
            [innerHTML]="(interconsulta.contenido || interconsulta.descripcion || interconsulta.description || interconsulta.motivo || interconsulta.reason) | safeHtml">
          </div>
          <div
            *ngIf="!(interconsulta.contenido || interconsulta.descripcion || interconsulta.description || interconsulta.motivo || interconsulta.reason)"
            class="resumen-coleccion-item-content mt-2 text-sm text-gray-700">
            {{ formatearItem(interconsulta) }}
          </div>
        </article>
      </div>
    </div>
  </div>

  <ng-template #noData>
    <div class="flex items-center justify-center h-full p-6">
      <div class="text-center">
        <svg class="w-16 h-16 text-gray-300 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
        <p class="text-sm text-gray-500">Selecciona una nota del histórico</p>
      </div>
    </div>
  </ng-template>
</div>



